import customAxios from "../../customAxios";
import {SUB_LOGIN} from "../../routes";

type Props = {
  _id: string;
  phoneNumber: string;
};

const addSubLogin = async (props: Props) => {
  try {
    return (
      await customAxios.put(SUB_LOGIN + `/${props._id}`, {
        phoneNumber: props.phoneNumber,
      })
    ).data;
  } catch (error: unknown) {
    console.error({SUB_LOGIN: error});
    return false;
  }
};

export default addSubLogin;
